import React, { useState } from "react";
import Header from "../Header/Header";
import "./viewrfq.css";
import {
  TextInputField,
  TextInput,
  Select,
  option,
  FilePicker,
  Textarea,
  Checkbox,
} from "evergreen-ui";

const ViewRfq = () => {
  const [basicClose, setbasicClose] = useState({
    card1: true,
    card2: true,
    card3: true,
    card4: true,
    card5: true,
    card6: true,
    card7: true,
  });
  return (
    <div>
      <Header title={"View RFQ"} />
      <div>
        <div className="rfqRightDivHead">
          <div>
            <div className="rfqRightDivHeadHeading">
              Swimming Pool Renovation
            </div>
            <div className="rfqRightDivHeadSubHeading">Godrej Sky</div>
          </div>
          <div>
            {/* <button className="applyNowbtnRfq">Submit Qoute</button> */}
          </div>
        </div>
      </div>
      <div className="rfqRightDivData" id="imprightDiveData">
        {/* -----------basic info----------------- */}
        <div>
          <div className="basicDetailsDivRfq">
            <div>
              <img src="./images/stratum/basicInfo.svg" alt="" />
              <span className="rfqsrightdivSubName">Basic Info</span>
            </div>
            <div
              className="basicDetailsDivRfqLogoDrop"
              onClick={() => {
                setbasicClose({ ...basicClose, card1: !basicClose.card1 });
              }}
            >
              {" "}
              <img src="./images/stratum/dropUpLogo.svg" alt="" />
            </div>
          </div>
          {basicClose.card1 && (
            <div className="basicDetailsDivRfqColumDiv">
              <div>
                <p>PR NO</p>
                <div>BA9212320</div>
                <p>POSTED ON</p>
                <div>BA9212320</div>
              </div>
              <div>
                <p>RFQ NO</p>
                <div>BA9212320</div>
                <p>CLOSING ON</p>
                <div>BA9212320</div>
              </div>
              <div>
                <p>MANAGED BY</p>
                <div>BA9212320</div>
                <p>Expected Completion/Delivery</p>
                <div>BA9212320</div>
              </div>
            </div>
          )}
        </div>
        {/* -----------site visit----------------- */}
        <div>
          <div className="basicDetailsDivRfq">
            <div>
              <img src="./images/stratum/basicInfo.svg" alt="" />
              <span className="rfqsrightdivSubName">Site Visit</span>
            </div>
            <div
              className="basicDetailsDivRfqLogoDrop"
              onClick={() => {
                setbasicClose({ ...basicClose, card2: !basicClose.card2 });
              }}
            >
              {" "}
              <img src="./images/stratum/dropUpLogo.svg" alt="" />
            </div>
          </div>
          {basicClose.card2 && (
            <div className="basicDetailsDivRfqColumDiv" id="columnImpRfq">
              <div>
                <p>date</p>
                <div>BA9212320</div>
              </div>
              <div>
                <p>time</p>
                <div>BA9212320</div>
              </div>
            </div>
          )}
        </div>
        {/* -----------contact info----------------- */}
        <div>
          <div className="basicDetailsDivRfq">
            <div>
              <img src="./images/stratum/basicInfo.svg" alt="" />
              <span className="rfqsrightdivSubName">Contact Info</span>
            </div>
            <div
              className="basicDetailsDivRfqLogoDrop"
              onClick={() => {
                setbasicClose({ ...basicClose, card3: !basicClose.card3 });
              }}
            >
              {" "}
              <img src="./images/stratum/dropUpLogo.svg" alt="" />
            </div>
          </div>
          {basicClose.card3 && (
            <div className="basicDetailsDivRfqColumDiv" id="columnImpRfq">
              <div>
                <p>CONTACT PERSON</p>
                <div>BA9212320</div>
                <p>CONTACT NUMBER</p>
                <div>BA9212320</div>
              </div>
              <div>
                <p>EMAIL</p>
                <div>BA9212320</div>
              </div>
            </div>
          )}
        </div>

        {/* -----------ITEMS---------------- */}
        <div>
          <div className="basicDetailsDivRfq">
            <div>
              <img src="./images/stratum/item.svg" alt="" />
              <span className="rfqsrightdivSubName">Items</span>
            </div>
            <div
              className="basicDetailsDivRfqLogoDrop"
              onClick={() => {
                setbasicClose({ ...basicClose, card4: !basicClose.card4 });
              }}
            >
              {" "}
              <img src="./images/stratum/dropUpLogo.svg" alt="" />
            </div>
          </div>
          {basicClose.card4 && (
            <div
              className="basicDetailsDivRfqColumDiv"
              id="basicDetailsDivRfqColumDivimp"
            >
              <table className="rfqtable">
                <tr className="rfqtableHead">
                  <th>ITEMS</th>
                  <th>UOM</th>
                  <th>QTY</th>
                  {/* <th>AMOUNT</th>
                <th>VAT</th>
                <th>TOTAL</th> */}
                </tr>
                <tr className="rfqtablData">
                  <td>Alfreds Futterkiste</td>
                  <td>Maria Anders</td>
                  <td>Germany</td>
                  {/*<td>
                   <TextInput
                    className="mgbottominput"
                    width={88}
                    height={32}
                    name="tradeLicenseNumber"
                    placeholder="xxxxxxxxxx"
                    value={""}
                    onChange={""}
                  />
                </td>
                <td>
                  <TextInput
                    className="mgbottominput"
                    width={88}
                    height={32}
                    name="tradeLicenseNumber"
                    placeholder="xxxxxxxxxx"
                    value={""}
                    onChange={""}
                  />{" "}
                </td>
                <td>
                  <TextInput
                    className="mgbottominput"
                    width={88}
                    height={32}
                    name="tradeLicenseNumber"
                    placeholder="xxxxxxxxxx"
                    value={""}
                    onChange={""}
                  />{" "}
                </td> */}
                </tr>
                <tr className="rfqtablData">
                  <td>Alfreds Futterkiste</td>
                  <td>Maria Anders</td>
                  <td>Germany</td>
                </tr>
                <tr className="rfqtablData">
                  <td>Alfreds Futterkiste</td>
                  <td>Maria Anders</td>
                  <td>Germany</td>
                </tr>{" "}
                <tr className="rfqtablData">
                  <td>Alfreds Futterkiste</td>
                  <td>Maria Anders</td>
                  <td>Germany</td>
                </tr>{" "}
                <tr className="rfqtablData">
                  <td>Alfreds Futterkiste</td>
                  <td>Maria Anders</td>
                  <td>Germany</td>
                </tr>{" "}
                <tr className="rfqtablData">
                  <td>Alfreds Futterkiste</td>
                  <td>Maria Anders</td>
                  <td>Germany</td>
                </tr>{" "}
                <tr className="rfqtablData">
                  <td>Alfreds Futterkiste</td>
                  <td>Maria Anders</td>
                  <td>Germany</td>
                </tr>
              </table>
            </div>
          )}
        </div>

        {/* -----------scope of work---------------- */}

        <div>
          <div className="basicDetailsDivRfq">
            <div>
              <img src="./images/stratum/scopeofwork.svg" alt="" />
              <span className="rfqsrightdivSubName">Scope of Work</span>
            </div>
            <div
              className="basicDetailsDivRfqLogoDrop"
              onClick={() => {
                setbasicClose({ ...basicClose, card5: !basicClose.card5 });
              }}
            >
              {" "}
              <img src="./images/stratum/dropUpLogo.svg" alt="" />
            </div>
          </div>
          {basicClose.card5 && (
            <div className="basicDetailsDivRfqColumDiv">
              <div>
                <div className="rfqMaxWidth setMaxWidth">
                  FAHU 01.1. Repair of FAHU Panel Board.2. Repair of FAHU
                  Exhaust Blower3. Repair of Heat Recovery WheelFAHU 02.1.
                  Replacement of Power Cable2. Repair of FAHU Exhaust Blower3.
                  Repair of Heat Recovery Wheel
                </div>
              </div>
            </div>
          )}
        </div>
        {/* -----------Terms & Conditions -01---------------- */}

        <div>
          <div className="basicDetailsDivRfq">
            <div>
              <img src="./images/stratum/tandc.svg" alt="" />
              <span className="rfqsrightdivSubName">
                Terms & Conditions -01
              </span>
            </div>
            <div
              className="basicDetailsDivRfqLogoDrop"
              onClick={() => {
                setbasicClose({ ...basicClose, card6: !basicClose.card6 });
              }}
            >
              {" "}
              <img src="./images/stratum/dropUpLogo.svg" alt="" />
            </div>
          </div>
          {basicClose.card6 && (
            <div className="basicDetailsDivRfqColumDiv">
              <div>
                <div className="rfqMaxWidth setMaxWidth">
                  An Intellectual Property clause will inform users that the
                  contents, logo and other visual media you created is your
                  property and is protected by copyright laws. A Termination
                  clause will inform users that any accounts on your website and
                  mobile app, or users' access to your website and app, can be
                  terminated in case of abuses or at your sole discretion. A
                  Governing Law clause will inform users which laws govern the
                  agreement. These laws should come from the country in which
                  your company is headquartered or the country from which you
                  operate your website and mobile app.
                </div>
              </div>
            </div>
          )}
        </div>
        {/* -----------Terms & Conditions -02--------------- */}

        <div>
          <div className="basicDetailsDivRfq">
            <div>
              <img src="./images/stratum/tandc.svg" alt="" />
              <span className="rfqsrightdivSubName">
                Terms & Conditions -02
              </span>
            </div>
            <div
              className="basicDetailsDivRfqLogoDrop"
              onClick={() => {
                setbasicClose({ ...basicClose, card7: !basicClose.card7 });
              }}
            >
              {" "}
              <img src="./images/stratum/dropUpLogo.svg" alt="" />
            </div>
          </div>
          {basicClose.card7 && (
            <div className="basicDetailsDivRfqColumDiv">
              <div>
                <div className="rfqMaxWidth setMaxWidth">
                  An Intellectual Property clause will inform users that the
                  contents, logo and other visual media you created is your
                  property and is protected by copyright laws. A Termination
                  clause will inform users that any accounts on your website and
                  mobile app, or users' access to your website and app, can be
                  terminated in case of abuses or at your sole discretion. A
                  Governing Law clause will inform users which laws govern the
                  agreement. These laws should come from the country in which
                  your company is headquartered or the country from which you
                  operate your website and mobile app.
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewRfq;
